import * as XLSX from "xlsx";
import {
  getFileContentAsArrayBuffer,
  getFileContentAsString,
} from "./file.utils";
import { TypeIndex } from "../../../../shared/index";
import { StringUtils } from "../../../../shared/utils/string.utils";

export async function importXlsx(file: File) {
  const buffer: TypeIndex<any> = {};

  const book = XLSX.read(await getFileContentAsArrayBuffer(file), {
    type: "array",
  });
  let currentLanguage = "";
  /** read data from different sheet names */
  // book.SheetNames.map((name) => {
  //   const sheet = book.Sheets[name];
  //   buffer[name] = importDocs(sheet);
  //   console.log(name);
  // });

  /** read data only from the first page */
  const name = book.SheetNames[0];
  if (name !== undefined && name.includes("_")) {
    currentLanguage = name.split("_")[1].toLowerCase();
  } else {
    // default import language
    currentLanguage = "en";
  }
  const sheet = book.Sheets[name];
  buffer[name] = importDocs(sheet);

  sessionStorage.setItem("language", currentLanguage);
  return buffer;
}

export function parseJson(arg: string): any[] {
  return JSON.parse(arg);
}

export async function importJson(file: File) {
  const buffer: TypeIndex<any> = {};
  await getFileContentAsString(file);
  buffer["data"] = parseJson(await getFileContentAsString(file));
  return buffer;
}

function importDocs(sheet: XLSX.WorkSheet) {
  const rows: string[][] = XLSX.utils.sheet_to_json(sheet, {
    raw: true,
    header: 1,
  });

  if (rows.length < 2) return rows; // Only header or empty

  // Special case for the "lastOrderDate" column in RAD files: dates are imported as strings in "dd.mm.yyyy" format
  const headers = rows[0];
  const dateColIndex = headers.findIndex((h) => h.includes("lastOrderDate"));

  if (dateColIndex === -1) return rows; // no "lastOrderDate" column

  rows.slice(1).forEach((row: any) => {
    const cellValue = row[dateColIndex];

    const invalidStrings = [
      "#N/A",
      "#VALUE!",
      "00.01.1900",
      "00.01.1970",
      "01.00.1900",
    ];

    // Skip if cell is null, undefined, or a blank string (after trimming)
    if (
      cellValue == null ||
      (typeof cellValue === "string" &&
        (cellValue.trim() === "" ||
          invalidStrings.includes(cellValue.trim().toUpperCase())))
    ) {
      row[dateColIndex] = 0;
      return;
    }

    if (typeof cellValue === "number") {
      // Excel serial number
      row[dateColIndex] = (cellValue - 25569 + 1) * 86400 * 1000;
      return;
    }

    if (typeof cellValue === "string") {
      const [dayStr, monthStr, yearStr] = cellValue.split(".");
      const day = Number(dayStr);
      const month = Number(monthStr);
      const year = Number(yearStr);

      if (!day || !month || !year) {
        return 0;
      }

      row[dateColIndex] = new Date(Date.UTC(year, month - 1, day)).getTime();
      return;
    }

    if (cellValue instanceof Date) {
      row[dateColIndex] = cellValue.getTime();
      return;
    }

    return 0;
  });

  return rows;
}

export function setCreateTimeAndUpdateTime(doc: any) {
  if (StringUtils.isNullOrEmpty(doc["create_time"])) {
    doc.create_time = Date.now();
    doc.update_time = Date.now();
  } else {
    doc.create_time = Number(doc["create_time"]);
    doc.update_time = doc.create_time;
  }

  return doc;
}
